import api from "@/services/api"

export async function getOrder({ orderId }) {
  const result = await api.get(`/api/v1/order/${orderId}`)

  return result.data
}
